import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { PortalGlobals } from '../../../portalglobals'

@Component({
    selector: 'confirmation',
    templateUrl: 'confirmation.html'
})
export class ConfirmationComponent implements OnInit {
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    ErrorMessages: any[]

    constructor(private router: Router, private _enrollementGateway: EnrollmentGateway, public _global: PortalGlobals) {}

    ngOnInit() {
        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)

        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
    }

    enrollNewClient(): void {
        this.enrollment = {} as EnrollmentViewModel
        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/data-entry/Step1'])
    }

    completeEnrollment(): void {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/data-entry/Step2'])
    }
}
